<template>
    <card class="stats-card">
        <div class="stats-card-body">
            <div class="stats-card-main">
                <div class="stats-card-icon" v-if="$slots.header">
                    <slot name="header"></slot>
                </div>
                <div class="stats-card-content" v-if="$slots.content">
                    <slot name="content"></slot>
                </div>
            </div>
            <div class="stats-card-footer" v-if="$slots.footer">
                <hr />
                <slot name="footer"></slot>
            </div>
        </div>
    </card>
</template>
<script>
import Card from './Card.vue';

export default {
    name: 'stats-card',
    components: {
        Card,
    },
};
</script>
<style scoped>
.stats-card {
    height: 100%;
}

.stats-card-body {
    min-height: 150px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
}

.stats-card-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    gap: 0.5rem;
}

.stats-card-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 60px;
}

.stats-card-content {
    flex: 1;
    min-width: 0;
    text-align: right;
    overflow: hidden;
}

/* 確保內容文字可以自動換行或截斷 */
.stats-card-content :deep(p),
.stats-card-content :deep(span),
.stats-card-content :deep(.card-category),
.stats-card-content :deep(.card-title) {
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    justify-self: end;
}

/* 數字標題樣式 - 自適應字體大小 */
.stats-card-content :deep(.card-title) {
    font-size: clamp(1.25rem, 3vw, 2rem);
    line-height: 1.2;
    margin-bottom: 0.25rem;
}

.stats-card-content :deep(.card-category) {
    font-size: clamp(0.75rem, 2vw, 0.875rem);
    line-height: 1.3;
}

.stats-card-footer {
    margin-top: auto;
}

.stats-card-footer hr {
    margin: 0.75rem 0;
}

.stats-card-footer :deep(.stats) {
    font-size: clamp(0.7rem, 1.5vw, 0.85rem);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* RWD 響應式調整 */
@media (max-width: 1200px) {
    .stats-card-body {
        min-height: 140px;
    }

    .stats-card-icon {
        min-width: 50px;
    }
}

@media (max-width: 992px) {
    .stats-card-main {
        flex-direction: column;
        gap: 0.75rem;
    }

    .stats-card-icon {
        min-width: auto;
        align-self: flex-start;
    }

    .stats-card-content {
        text-align: right;
        width: 100%;
    }
}

@media (max-width: 576px) {
    .stats-card-body {
        min-height: 120px;
        padding: 0.5rem;
    }

    .stats-card-main {
        gap: 0.5rem;
    }
}
</style>
